import { isEmpty, omit, orderBy } from "lodash";

import { District, RowData } from "@hubcapp/components/DistrictsTable/types";
import { District as SchemaDistrict } from "@hubcapp/types";
import { findById } from "@ds-developer/frontend";

export const mapDistrictsToTableData = (
  instructorDistricts: District[] = [],
  allDistricts: District[] = [],
): RowData[] => {
  if (isEmpty(allDistricts)) {
    return [];
  }

  const rowData = allDistricts.map(district => {
    const matchingDistrict = findById(instructorDistricts, district.id, {
      id: "",
      sectors: [],
      postcode: "",
    });

    return {
      ...district,
      tableData: { checked: Boolean(matchingDistrict?.id) },
      sectors: district.sectors.map(sector => {
        const matchingSector = findById(
          matchingDistrict?.sectors || [],
          sector.id,
        );
        return {
          ...sector,
          isSelected: Boolean(matchingSector),
        };
      }),
    };
  });

  return rowData as RowData[];
};

export const transformToStateData = (districts: SchemaDistrict[]) => {
  const result = districts.map((district: SchemaDistrict) => {
    const sectors =
      district.sectors?.map(sector => ({
        id: sector?.id || "",
        name: sector?.sectorCode.includes(district.districtCode)
          ? sector?.sectorCode
          : `${district.districtCode} ${sector?.sectorCode}`,
      })) || [];

    return {
      id: district.id,
      postcode: district.districtCode,
      sectors: orderBy(sectors, "name", "asc"),
    };
  });

  return orderBy(result, "postcode", "asc");
};

export const transformToUpdatedDistricts = (districts: RowData[]) =>
  districts
    .filter(district => district.sectors.some(sector => sector.isSelected))
    .map(district => ({
      ...district,
      sectors: district.sectors.filter(sector => sector.isSelected),
      sectorsToOptOut: district.sectors.filter(sector => !sector.isSelected),
    }))
    .map(district => omit(district, "tableData"));
